import { BASE_URL } from "../../services/apiClient";

export const groupHandler = {
  entityType: "group",

  getFieldValue: (field, selectedItem, userDetails) => {
    if (!selectedItem) return "";
    return selectedItem[field.key] || "";
  },

  mapToApiFormat: (
    formData,
    originalItem,
    userDetails,
    isCreateOperation = false
  ) => {
    // Prevent updates to Administrators group name and description
    if (originalItem && originalItem.name === "Administrators") {
      return {
        name: originalItem.name, // Keep original name
        description: originalItem.description, // Keep original description
      };
    }

    // This is now only used for PUT operations since POST happens immediately
    return {
      name: formData.name,
      description: formData.description,
    };
  },

  createApiDataForImmediate: (name) => {
    return {
      id: 0,
      name: name,
      description: ".",
      creationDate: new Date().toISOString(),
      isChecked: true,
      isEnabled: true,
    };
  },

  createLocalItemFromServer: (serverResponseId, name) => {
    const localItem = {
      id: serverResponseId,
      name: name,
      description: "",
      creationDate: Date.now(),
      isChecked: true,
      isEnabled: true,
    };

    return localItem;
  },

  updateItems: (formData, itemId, { setGroups }) => {
    setGroups((prevGroups) =>
      prevGroups.map((group) =>
        group.id === itemId
          ? {
              ...group,
              name: formData.name || group.name,
              description: formData.description || group.description,
            }
          : group
      )
    );

    // Return updated item for immediate use
    return {
      id: itemId,
      name: formData.name,
      description: formData.description,
    };
  },

  createUpdatedItem: (formData, itemId) => ({
    name: formData.name,
    description: formData.description,
  }),

  generateNewItemName: (existingItems) => {
    let counter = 1;
    let name;

    do {
      name = `New Group${counter}`;
      counter++;
    } while (existingItems.some((item) => item.name === name));

    return name;
  },

  getAssignmentsURL: (itemId) => `${BASE_URL}/Groups/${itemId}/users`,
  addAssignmentURL: (itemId, assignableId) =>
    `${BASE_URL}/Groups/${itemId}/add-user/${assignableId}`,
  removeAssignmentURL: (itemId, assignableId) =>
    `${BASE_URL}/Groups/${itemId}/remove-user/${assignableId}`,
  updateItemURL: (itemId) => `${BASE_URL}/Groups/${itemId}`,
  deleteItemURL: (itemId) => `${BASE_URL}/Groups/${itemId}`,
  createItemURL: () => `${BASE_URL}/Groups`,
};
